import React, { useState, useEffect, useRef } from 'react';
import format from 'date-fns/format';
import Drawer from '@mui/material/Drawer';
import DOMPurify from 'dompurify';
import './index.css';
import Select from 'react-select';
import { AiOutlineUser, AiOutlineCalendar } from 'react-icons/ai';
import { getApi, postApi } from '../../services/api';
import { MdDeleteOutline, MdOutlineOpenInNew } from 'react-icons/md';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { showSnack } from 'react-redux-snackbar';
import { AiOutlineDown } from 'react-icons/ai';
import { AiOutlineUp } from 'react-icons/ai';
// import { Timeline, TimelineEvent } from 'react-event-timeline';
import { BsCircle } from 'react-icons/bs';
import { BsCircleFill } from 'react-icons/bs';
import Issue from '../../images/Issue.png';
import Time from '../../images/Time.png';
import { useDebounce } from 'usehooks-ts';
import { IoFilter } from 'react-icons/io5';
import { FaRegBell } from 'react-icons/fa';

import {
	Pagination,
	Tag,
	Avatar,
	Typography,
	Select as SelectAnt,
	Empty,
	Drawer as AntDrawer,
	Button,
	Form,
	Input,
	Tabs,
	Table,
	Modal,
} from 'antd';
import _, { debounce } from 'lodash';
import { UserOutlined } from '@ant-design/icons';
import ApprovalRequests from './approvals';
import OutForDeliverUpdate from './OutForDeliverUpdate';

const { Paragraph, Text } = Typography;

const incidentsList = [
	{
		employee: {
			name: 'santhosh h',
			employeeId: '121',
			email: 'santhosh@assetze.com',
		},
		createdAt: new Date(),
		errorMessage: 'Windows Suddenly Crashed',
		assetId: 'sGUEEkY4Z3',
		assetName: 'Lenovo ThinkPad P52',
		priority: 'high',
		assignedTo: 'Vikas',
		status: 'Pending',
	},
	{
		employee: {
			name: 'Sooraj',
			employeeId: '1213',
			email: 'sooraj@assetze.com',
		},
		createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
		errorMessage: 'Wifi is not working',
		assetId: 'sGUEEkY4Z3',
		assetName: 'Lenovo ThinkPad P52',
		priority: 'medium',
		assignedTo: 'Dheeraj',
		status: 'Pending',
	},
];

const itAdmins = [
	{ value: 'adminid1', label: 'Vijay Rao' },
	{ value: 'adminid2', label: 'Krishna Kumar' },
	{ value: 'adminid3', label: 'Amith Ghosh' },
];

const markAsOptions = [
	{ value: 'open', label: 'Open' },
	{ value: 'closed', label: 'Closed' },
	{ value: 'waiting-for-review', label: 'Waiting For Review' },
	{ value: 'pending', label: 'Un Assigned' },
];

const issueTypes = [
	{ value: 'sofware-issue', label: 'Software Issue' },
	{ value: 'hardware-issue', label: 'Hardware Issue' },
	{ value: 'charger-issue', label: 'Charger Issue' },
	{ value: 'not-switching-on', label: 'Not Switching On' },
	{ value: 'Others', label: 'Other Issues' },
	{ value: 'request-for', label: 'Request For' },
	{ value: 'not-sure', label: "Don't Know the Reason" },
	{ value: 'pre-emp-device-selection', label: 'Employee onboarding Device selection' },
];

const IncidentsComponent = function () {
	const [incidents, setIncidents] = useState([]);
	const [itAdmins, setItAdmins] = useState([]);
	const [showIncidentInfo, toggleIncidentInfo] = useState(false);
	const [selectedIncidentId, setSelectedIncidentId] = useState(null);
	const [page, setPage] = useState(1);
	const [employeeList, setEmployeeList] = useState([]);
	const [limit, setLimit] = useState(10);
	const [total, setTotal] = useState(0);
	const [selectedTicketTypes, setSelectedTicketTypes] = useState([]);
	const [selectedStatusList, setSelectedStatus] = useState(null);
	const [selectedAdminToFilter, setFilterByAdmin] = useState(null);
	const [filterDrawer, setFilterDrawer] = useState(false);
	const [form] = Form.useForm();

	useEffect(() => {
		const getAdminList = async function () {
			const resp = await postApi({}, '/users/get-admins');
			if (resp.type === 'success') {
				setItAdmins(
					resp.admins.map((el) => {
						return {
							value: el._id,
							label: el.firstName,
						};
					})
				);
			}
		};
		getAdminList();
	}, []);

	useEffect(() => {
		const getTicketList = async function () {
			const payload = {
				ticketTypes: selectedTicketTypes,
			};

			if (selectedStatusList) {
				payload['status'] = [selectedStatusList];
			}

			if (selectedAdminToFilter) {
				payload['adminAssignedTo'] = [selectedAdminToFilter];
			}

			const resp = await postApi(
				{
					page,
					limit,
					filter: payload,
				},
				'/assets/get-tickets'
			);
			if (resp.type === 'success') {
				setIncidents(resp.data);
				//console.log(incidents);
				setTotal(resp.total);
			}
		};

		getTicketList();
	}, [page, limit, selectedTicketTypes, selectedStatusList, selectedAdminToFilter]);

	const onClearFilter = () => {
		setSelectedTicketTypes([]);
		setSelectedStatus(null);
		setFilterByAdmin(null);
		setPage(1);
		setLimit(10);
	};

	const openIncidentInfo = (incidentId) => {
		setSelectedIncidentId(incidentId);
		toggleIncidentInfo(true);
	};

	const updatedIncident = (incidentId, updatedData) => {
		setIncidents(
			incidents.map((el) => {
				if (el._id === incidentId) {
					return updatedData;
				}
				return el;
			})
		);
	};

	const onIssueSelected = async function (value) {
		console.log(value, 'onIssueSelected');
		setSelectedTicketTypes(value);
	};
	const onStatusSelected = async function (value) {
		console.log(value, 'onStatusSelected');
		setSelectedStatus(value);
	};

	const onTicketAssignedTo = async function (value) {
		console.log(value, 'onTicketAssignedTo');
		setFilterByAdmin(value);
	};

	const selectedIncident = incidents.find((el) => el._id === selectedIncidentId);

	// if (incidents.length === 0) {
	// 	return  <Empty />;
	// }

	const statusOptions = [
		{
			label: 'Open',
			value: 'open',
		},
		{
			label: 'Closed',
			value: 'closed',
		},
		{
			label: 'Waiting for review',
			value: 'waiting-for-review',
		},
		{
			label: 'Unassigned',
			value: 'pending',
		},
	];

	const searchEmployeeFilter = debounce(async (filterText) => {
		try {
			if (filterText && filterText.length >= 3) {
				const resp = await postApi({ filterText }, '/users/get-employee');
				console.log(resp);
				if (resp.type === 'success') {
					setEmployeeList(
						resp.employeeList.map((el) => ({
							label: `${el.name} ${el.email ? `(${el.email})` : ''} `,
							value: el.empId,
						}))
					);
				}
			} else {
				setEmployeeList([]);
			}
		} catch (e) {
			console.error(e);
		}
	}, 1000);

	const onSubmit = (data) => {
		console.log(data);
	};

	return (
		<div className="incidents-container">
			<div style={{ display: 'flex', justifyContent: 'right' }} className="incident-filter">
				<Button
					onClick={() => {
						setFilterDrawer(true);
					}}
					icon={<IoFilter />}
				>
					Filters
				</Button>
				{/* <div>Filter By:</div>
				<SelectAnt
					mode="multiple"
					allowClear
					style={{
						width: '100%',
					}}
					placeholder="Filter By Ticket Type"
					defaultValue={selectedTicketTypes}
					onChange={onIssueSelected}
					options={issueTypes}
					className="filter-select"
				/> */}

				<AntDrawer
					open={filterDrawer}
					title="Select Filters"
					onClose={() => {
						setFilterDrawer(false);
					}}
				>
					<Form form={form} style={{ height: '100%' }} onFinish={onSubmit}>
						<div className="incident-filters-div">
							<div className="innerdiv">
								<div>
									<div className="heading-div">Ticket Type:</div>
									<Form.Item name={'type'}>
										<SelectAnt
											mode="multiple"
											allowClear
											style={{
												width: '100%',
											}}
											placeholder="Select Ticket Type"
											onChange={onIssueSelected}
											options={issueTypes}
											className="filter-select"
										/>
									</Form.Item>
								</div>
								{/* <div>
									<div className='heading-div'>Created By:</div>
									<Form.Item name={'createdBy'}>
										<SelectAnt
											showSearch
											style={{
												width: '100%',
											}}
											filterOption={false}
											placeholder="Select Created by"
											onSearch={(val) => {
												searchEmployeeFilter(val);
											}}
											options={employeeList}
											className="filter-select"

										></SelectAnt>
									</Form.Item>
								</div> */}
								<div>
									<div className="heading-div">Status:</div>
									<Form.Item name={'status'}>
										<SelectAnt
											allowClear
											style={{
												width: '100%',
											}}
											placeholder="Select Status"
											options={statusOptions}
											className="filter-select"
											onChange={onStatusSelected}
											value={selectedStatusList}
										/>
									</Form.Item>
								</div>

								<div>
									<div className="heading-div">Assigned To :</div>
									<Form.Item name={'assignedTo'}>
										<SelectAnt
											allowClear
											style={{
												width: '100%',
											}}
											placeholder="Select Assigned to"
											options={itAdmins}
											className="filter-select"
											onChange={onTicketAssignedTo}
											value={selectedAdminToFilter}
										/>
									</Form.Item>
								</div>
							</div>
							<div className="action-div">
								<Button
									style={{ width: '100%' }}
									onClick={() => {
										form.submit();
										setFilterDrawer(false);
									}}
									size="large"
									type="primary"
								>
									View Results
								</Button>
								<Button
									style={{ width: '100%' }}
									onClick={() => {
										form.resetFields();
										onClearFilter();
									}}
									size="large"
								>
									Clear Filters
								</Button>
							</div>
						</div>
					</Form>
				</AntDrawer>
			</div>

			{incidents.length === 0 ? <Empty /> : null}

			<div className="incidents-container-list">
				{incidents.map((el, index) => {
					return (
						<EachIncident
							openIncidentInfo={openIncidentInfo}
							itAdmins={itAdmins}
							key={index}
							incident={el}
							index={index}
							updatedIncident={updatedIncident}
						/>
					);
				})}
			</div>

			<div
				style={{
					marginTop: '20px',
					marginLeft: 'auto',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'end',
				}}
			>
				<Pagination
					onShowSizeChange={(page, pageSize) => {
						setPage(page);
						setLimit(pageSize);
					}}
					onChange={(page, pageSize) => {
						setPage(page);
						setLimit(pageSize);
					}}
					current={page}
					defaultCurrent={page}
					total={total}
					pageSize={limit}
					align={'end'}
				/>
			</div>

			<Drawer
				anchor={'right'}
				open={showIncidentInfo}
				onClose={() => {
					toggleIncidentInfo(!showIncidentInfo);
				}}
			>
				<IncidentActionInfo updatedIncident={updatedIncident} incident={selectedIncident} />
			</Drawer>
		</div>
	);
};

const IncidentActionInfo = function ({ incident, updatedIncident }) {
	const [showConversation, toggleShowConversation] = useState(false);
	const [data, setData] = useState([]);
	const [msg, setMsg] = useState(null);
	const [msgPopup, setMsgPopup] = useState(false);
	const [approvalId, setApprovalId] = useState(null);
	const dispatch = useDispatch();
	const { TextArea } = Input;

	useEffect(() => {
		getAllrequest();
	}, []);

	const getAllrequest = async () => {
		const resp = await getApi(`/assets/ticket/approval/list?ticketId=${incident._id}`);
		console.log(resp);
		setData(
			resp.data.map((el) => {
				return {
					createdBy: el.createdByAdmin.firstName,
					status: el.status,
					actions: (
						<div>
							<Button
								style={{ marginRight: '20px' }}
								onClick={() => {
									setApprovalId(el._id);
								}}
								icon={<FaRegBell />}
							></Button>
							<Button icon={<MdDeleteOutline />}></Button>
						</div>
					),
					createdAt: format(new Date(el.createdAt), 'dd MMM, HH:mm'),
				};
			})
		);
	};

	const columns = [
		{
			title: 'createdBy',
			dataIndex: 'createdBy',
			key: 'createdBy',
		},
		{
			title: 'Status',
			dataIndex: 'status',
			key: 'status',
		},
		{
			title: 'createdAt',
			dataIndex: 'createdAt',
			key: 'createdAt',
		},
		{
			title: 'Actions',
			dataIndex: 'actions',
			key: 'actions',
			width: '20%',
		},
	];

	const createRequest = async () => {
		if (msg === null || msg.trim() === '') {
			return dispatch(
				showSnack('INVALID_HEALTH', {
					label: 'Write message to create request',
					timeout: 3000,
				})
			);
		}
		const resp = await postApi({ ticketId: incident._id, message: msg }, '/assets/ticket/approval');
		if (resp.type === 'success') {
			dispatch(
				showSnack('INVALID_HEALTH', {
					label: 'Approval Request Created Successfully',
					timeout: 3000,
				})
			);
			setMsgPopup(false);
			setMsg(null);
			getAllrequest();
		} else {
			return dispatch(
				showSnack('INVALID_HEALTH', {
					label: resp.error ? resp.error : 'An error occurred',
					timeout: 3000,
				})
			);
		}
	};

	const notifyAgain = async () => {
		const resp = await postApi(
			{ ticketId: incident._id, approvalRequestId: approvalId },
			'/assets/ticket/approval/notify'
		);
		if (resp.type === 'success') {
			dispatch(
				showSnack('INVALID_HEALTH', {
					label: 'Notified Successfully',
					timeout: 3000,
				})
			);
			approvalId(null);
		} else {
			return dispatch(
				showSnack('INVALID_HEALTH', {
					label: resp.error ? resp.error : 'An error occurred',
					timeout: 3000,
				})
			);
		}
	};
	const items = [
		{
			key: '1',
			label: 'Comments',
			children: <UserConversation updatedIncident={updatedIncident} incident={incident} />,
		},
		// {
		// 	key: '2',
		// 	label: 'Approval Request',
		// 	children: (
		// 		<div className="approval-request">
		// 			<div className="heading-div">
		// 				<h5>Approval Request</h5>
		// 				<Button
		// 					onClick={() => {
		// 						setMsgPopup(true);
		// 					}}
		// 				>
		// 					Create
		// 				</Button>
		// 			</div>
		// 			<Table style={{ marginTop: '20px' }} dataSource={data} columns={columns} />

		// 			<Modal
		// 				open={msgPopup}
		// 				onCancel={() => {
		// 					setMsgPopup(false);
		// 					setMsg(null);
		// 				}}
		// 				title="Create Approval Request"
		// 				zIndex={3000}
		// 				onOk={() => {
		// 					createRequest();
		// 				}}
		// 			>
		// 				<TextArea
		// 					value={msg}
		// 					onChange={(e) => {
		// 						setMsg(e.target.value);
		// 					}}
		// 					placeholder="Type your message here"
		// 					style={{ margin: '15px 0px' }}
		// 				/>
		// 			</Modal>

		// 			<Modal
		// 				open={approvalId}
		// 				onCancel={() => {
		// 					setApprovalId(null);
		// 				}}
		// 				zIndex={3000}
		// 				title="Confirm Notify Request"
		// 				onOk={() => {
		// 					notifyAgain();
		// 				}}
		// 			>
		// 				<p>Are you sure you want to notify again?</p>
		// 			</Modal>
		// 		</div>
		// 	),
		// },
	];

	if (!incident) {
		return null;
	}

	return (
		<div className="incidentinfo-container">
			<p>
				{incident.errorMessage}
				{'    '}
				<Tag color="#f50">{incident.issueType}</Tag>
			</p>
			<div className="name-container">
				<div>
					<AiOutlineUser /> {incident.employee?.email}
				</div>
				<div>
					<AiOutlineCalendar />
					{format(new Date(incident.createdAt), 'dd MMM yyyy')}
				</div>
				{/* <button
					onClick={() => {
						toggleShowConversation(!showConversation);
					}}
				>
					View Past Conversation
				</button> */}
			</div>
			<OutForDeliverUpdate incident={incident} />
			<div>
				<Tabs size="large" defaultActiveKey="1" items={items} />
			</div>
			{/* <UserConversation updatedIncident={updatedIncident} incident={incident} /> */}
		</div>
	);
};

const AlwaysScrollToBottom = () => {
	const elementRef = useRef();
	useEffect(() => elementRef.current.scrollIntoView());
	return <div ref={elementRef} />;
};

const getIncidentInfo = async function (incidentId) {
	const resp = await postApi({ incidentId }, '/users/incident-info');
	if (resp.type === 'success') {
		return resp.incident;
	}
};

const UserConversation = function ({ incident, updatedIncident }) {
	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		reset,
	} = useForm();
	const [incidentInfo, setIncidentInfo] = useState(incident);
	const [message, setMessage] = useState(null);
	const [cmts, setCmts] = useState([]);
	const { TextArea } = Input;
	const dispatch = useDispatch();
	useEffect(() => {
		let timer;

		timer = setInterval(async () => {
			const data = await getIncidentInfo(incidentInfo._id);
			if (data.comments && data.comments.length > incidentInfo.comments.length) {
				setIncidentInfo(data);
			}
		}, 1000 * 10);

		const getComments = async () => {
			const resp = await getApi(`/assets/ticket/comments?page=1&limit=10&ticketId=${incident._id}`);
			if (resp.type === 'success') {
				setCmts(resp.data);
			}
		};

		getComments();

		return () => {
			if (timer) clearInterval(timer);
		};
	}, [incidentInfo, setIncidentInfo]); // empty bracket calls the useEffect callback on initial render

	if (!incidentInfo) {
		return null;
	}

	const onSubmit = async function () {
		const data = { replyMsg: message };
		console.log(data);
		const resp = await postApi({ incidentId: incident._id, ...data }, '/users/add-comment');
		if (resp.type === 'success') {
			updatedIncident(incident._id, resp.incident);
			setMessage(null);
			reset({ replyMsg: '' });
		} else {
			dispatch(
				showSnack('INVALID_HEALTH', {
					label: resp.error,
					timeout: 3000,
				})
			);
		}
	};

	const comments = incidentInfo.comments;

	return (
		<>
			{/* <div className="conversation-container">
				<div className="content">
					{comments.map((eachComment, index) => {
						const dynamicClass = eachComment.msgType === 'employee' ? 'employee-message' : 'admin-message';
						return (
							<div className={dynamicClass} key={index}>
								<div>{eachComment.message}</div>
								<div className="date-message">
									{format(new Date(eachComment.createdAt), 'do MMM, EEE')} <br />
									{eachComment.fromUser} - {eachComment.msgType}
								</div>
							</div>
						);
					})}
					<AlwaysScrollToBottom />
				</div>
				<form onSubmit={handleSubmit(onSubmit)} className="reply-content">
					<input {...register('replyMsg', { required: true })} type={'text'} placeholder={'Reply'} />
					<button>Reply</button>
				</form>
			</div> */}
			<div className="message-div">
				<TextArea
					onChange={(e) => {
						setMessage(e.target.value);
					}}
					value={message}
					style={{ marginBottom: '10px' }}
					placeholder="Type your message here"
				/>
				<Button
					onClick={() => {
						onSubmit();
					}}
					style={{ marginBottom: '30px' }}
				>
					Send
				</Button>
				{cmts.map((eachComment, index) => {
					return (
						<div className="message-innerdiv">
							<div className="flex-div">
								<div>
									<Avatar style={{ marginRight: '8px' }}>
										{eachComment.fromUser[0].toUpperCase()}
									</Avatar>
									{eachComment.author?.employeeId?.email} / {eachComment.author?.role}
								</div>
								<div>
									{format(new Date(eachComment.createdAt), 'dd MMM, HH:mm')} <br />
								</div>
							</div>
							<ShowCommentText comment={eachComment} />
							{/* <div className="message-text">{eachComment.message}</div> */}
						</div>
					);
				})}
			</div>
		</>
	);
};

function ShowCommentText({ comment }) {
	if (comment.contentType === 'html') {
		const sanitizedContent = DOMPurify.sanitize(comment.message);
		return <div className="message-text" dangerouslySetInnerHTML={{ __html: sanitizedContent }} />;
	}
	return <div className="message-text">{comment.message}</div>;
}

const colors = ['#4285f4', '#ea4335', '#f7bd45', '#4ca954'];

const EachIncident = function ({ incident, index, itAdmins, openIncidentInfo, updatedIncident }) {
	const [adminComment, setAdminComment] = useState('');
	const [adminInsight, setAdminInsight] = useState('');
	const [view, setView] = useState(false);
	const [historyInfo, setHistoryInfo] = useState([]);
	const debounceVal = useDebounce(adminComment, 400);
	const insightDebounce = useDebounce(adminInsight, 400);
	const [cmtChange, setCmtChange] = useState('');
	const [adminChange, setAdminChange] = useState('');
	const [ellipsis, setEllipsis] = useState(true);

	const dispatch = useDispatch();
	// useEffect(() => {
	const addComment = async function () {
		const resp = await postApi(
			{ incidentId: incident._id, addComment: adminComment.trim(), type: 'comment' },
			'/users/ticket/admin-comment'
		);
		if (resp.type === 'success') {
			updatedIncident(incident._id, resp.incident);
		}
	};

	// 	addComment(adminComment);
	// }, [debounceVal]);

	// useEffect(() => {
	const addInsight = async function () {
		//console.log(adminComment,"ue");
		const resp = await postApi(
			{ incidentId: incident._id, addComment: adminInsight.trim(), type: 'insight' },
			'/users/ticket/admin-comment'
		);
		if (resp.type === 'success') {
			updatedIncident(incident._id, resp.incident);
		}
	};

	// 	addInsight(adminInsight);
	// }, [insightDebounce]);

	useEffect(() => {
		setAdminComment(incident.adminComment);
		setCmtChange(incident.adminComment);

		setAdminInsight(incident.adminInsights);
		setAdminChange(incident.adminInsights);
	}, [incident]);

	const logoChar = (incident.createdBy && incident.createdBy.name && incident.createdBy.name.charAt(0)) || 'A';
	const priorityClass = incident.priority === 'high' ? 'high' : 'medium';
	const bgColor = colors[2];

	const assignedToChanged = async function (value) {
		try {
			console.log(value, 'value');
			const resp = await postApi(
				{
					userId: value.value,
					incidentId: incident._id,
					assetId: incident.assetId,
				},
				'/assets/assign-incident'
			);
			if (resp.type === 'success') {
				updatedIncident(incident._id, resp.incident);
				dispatch(
					showSnack('INVALID_HEALTH', {
						label: `successfully assigned to user ${value.label}`,
						timeout: 3000,
					})
				);
			} else {
				dispatch(
					showSnack('INVALID_HEALTH', {
						label: resp.error,
						timeout: 7000,
					})
				);
			}
		} catch (e) {
			console.error(e);
		}
	};

	const getHistory = async function () {
		try {
			if (incident.assetId) {
				const resp = await postApi({ assetId: incident.assetId }, '/assets/incidents/get-history');
				if (resp.type === 'success') {
					console.log(resp.history, incident.assetId);
					setHistoryInfo(resp.history);
				}
			}
		} catch (e) {
			console.log(e);
		}
	};

	const handleChange = (event) => {
		setAdminComment(event.target.value);
	};

	const handleInsightChange = (event) => {
		setAdminInsight(event.target.value);
	};

	const updateIncidentState = async function (value) {
		try {
			console.log(value, 'value');
			const resp = await postApi(
				{ updateState: value.value, incidentId: incident._id },
				'/assets/modify-incident-status'
			);
			if (resp.type === 'success') {
				updatedIncident(incident._id, resp.incident);
				dispatch(
					showSnack('INVALID_HEALTH', {
						label: `successfully modified incident state to ${value.label}`,
						timeout: 3000,
					})
				);
			} else {
				dispatch(
					showSnack('INVALID_HEALTH', {
						label: resp.error,
						timeout: 7000,
					})
				);
			}
		} catch (e) {
			console.error(e);
		}
	};

	const markedValue = markAsOptions.filter((option) => option.value === incident.status);

	return (
		<div className="each-incident-container">
			<div className="incident-short">
				<div className="each-incident-info">
					<div>
						{/* <div style={{ backgroundColor: bgColor, color: 'white' }} className="logo-container">
						{logoChar}
					</div> */}
						<Avatar
							style={
								{
									// backgroundColor: '#fde3cf',
									// color: '#f56a00',
								}
							}
							size="large"
							gap={4}
						>
							{logoChar && logoChar.toUpperCase()}
						</Avatar>
					</div>
					<div className="each-incident-data">
						<div className="error-message">
							<Paragraph
								ellipsis={{
									rows: 3,
									expandable: true,
									onEllipsis: (ellipsis) => {
										console.log('Ellipsis changed:', ellipsis);
									},
								}}
							>
								{incident.errorMessage}
							</Paragraph>
						</div>
						<div className="name-container">
							<div>
								<AiOutlineUser /> {incident.employee?.email}
							</div>
							<div>
								<AiOutlineCalendar />
								{format(new Date(incident.createdAt), 'dd MMM yyyy')}
							</div>
							<MdOutlineOpenInNew
								style={{
									color: colors[3],
									marginLeft: '20px',
									fontSize: '16px',
									cursor: 'pointer',
								}}
								onClick={() => openIncidentInfo(incident._id)}
							/>
						</div>
						<div className="priority-container">
							<div className={priorityClass}>{incident.priority}</div>
							<div style={{ marginRight: '10px' }} className="asset-name">
								{incident.assetName}
							</div>
							<Tag color="#f50">{incident.issueType}</Tag>
							<Tag color="#3f3f3f">#{incident.id}</Tag>
						</div>
					</div>
				</div>
				<div className="each-incident-action">
					<Select
						value={itAdmins.filter((option) => option.value === incident.assignedTo)}
						placeholder={'Assign To'}
						options={itAdmins}
						isDisabled={markedValue[0].value === 'closed' ? true : false}
						onChange={(value) => assignedToChanged(value)}
					/>
					<Select
						value={markAsOptions.filter((option) => option.value === incident.status)}
						placeholder={'Mark As'}
						options={markAsOptions}
						onChange={(value) => updateIncidentState(value)}
					/>
					<div className="downward-arrow">
						{view ? (
							<AiOutlineUp
								onClick={() => {
									setView(!view);
								}}
							/>
						) : (
							<AiOutlineDown
								onClick={() => {
									setView(!view);
									getHistory();
								}}
							/>
						)}
					</div>
				</div>
			</div>
			{view ? (
				<div className="toggle-show-container">
					<div className="comment-insight">
						<div className="comment">
							<div className="heading">Comments</div>
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<textarea
									type="text"
									placeholder="Your comments"
									value={adminComment}
									onChange={handleChange}
								></textarea>
								{cmtChange === adminComment ? null : (
									<Button
										style={{ width: '100px', alignSelf: 'flex-end', marginTop: '10px' }}
										onClick={() => {
											addComment();
										}}
									>
										Save
									</Button>
								)}
							</div>
						</div>
						<div className="admin-insight">
							<div className="heading">Admin Insights</div>
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<textarea
									placeholder="Admin insights"
									value={adminInsight}
									onChange={handleInsightChange}
								></textarea>
								{adminChange === adminInsight ? null : (
									<Button
										style={{ width: '100px', alignSelf: 'flex-end', marginTop: '10px' }}
										onClick={() => {
											addInsight();
										}}
									>
										Save
									</Button>
								)}
							</div>
						</div>
					</div>

					{/* <ApprovalRequests incidentId={incident._id} /> */}

					<ShowIncidentHistory
						historyInfo={historyInfo}
						incident={incident}
						openIncidentInfo={openIncidentInfo}
					/>
				</div>
			) : null}
		</div>
	);
};

export default IncidentsComponent;
function ShowIncidentHistory({ historyInfo, incident, openIncidentInfo }) {
	const isExist = historyInfo.find((el) => el._id !== incident._id);

	if (!isExist) {
		return null;
	}

	return (
		<div className="history">
			<div className="heading">Other issues in the device</div>
			<div className="timeline">
				{historyInfo.map((el, index) => {
					if (el._id !== incident._id) {
						return (
							<div className="each-issue" key={index}>
								<div className="open-in-new">
									<div className="timestamp">
										<img src={Time} />
										<div>{format(new Date(el.createdAt), 'dd MMM yyyy')}</div>
									</div>
									<MdOutlineOpenInNew
										style={{
											color: colors[3],
											marginLeft: '20px',
											fontSize: '16px',
											cursor: 'pointer',
										}}
										onClick={() => openIncidentInfo(incident._id)}
									/>
								</div>
								<div className="issues">
									<img src={Issue} />
									<div>{el.errorMessage}</div>
								</div>
								<div className="name-status">
									<div className="user">
										<AiOutlineUser />
										<div>{el.assignedTo && el.assignedTo.firstName}</div>
									</div>
									<div className="status-each">
										<div className="resolved">{el.status}</div>
										<div>{format(new Date(incident.createdAt), 'dd MMM yyyy')}</div>
									</div>
								</div>
							</div>
						);
					}
				})}
			</div>
		</div>
	);
}
